<template>
  <r-button
    class="default-button"
    :style="customStyle"
    :label="label"
    :disable="disable"
    :loading="loading"
    size="16px"
    color="riseup-blue"
    text-color="riseup-beige"
    :icon="icon"
    padding="18px"
    custom-class="full-width r-text-bold"
    unelevated
    v-on="$listeners" />
</template>

<script>
import RButton from '@/components/base/RButton';

export default {
  name: 'DefaultButton',
  components: { RButton },
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: String,
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    customStyle: String,
  },
};
</script>

<style lang="scss" scoped>
.default-button {
  margin-bottom: 16px;
}
</style>
